import { render, staticRenderFns } from "./RaceFlucs.vue?vue&type=template&id=6bfd619b"
import script from "./RaceFlucs.vue?vue&type=script&lang=js"
export * from "./RaceFlucs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports